import { render, staticRenderFns } from "./list.vue?vue&type=template&id=2f301a3f&scoped=true"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"
import style0 from "./list.vue?vue&type=style&index=0&id=2f301a3f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f301a3f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f301a3f')) {
      api.createRecord('2f301a3f', component.options)
    } else {
      api.reload('2f301a3f', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=2f301a3f&scoped=true", function () {
      api.rerender('2f301a3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/products/list.vue"
export default component.exports